import styled, { css } from 'styled-components';

const TableContainer = styled.div<{}>(
  ({ theme }) => css`
    box-shadow: ${theme.getTokens().boxShadow.base};
  `,
);

export default TableContainer;
